import React from "react";
import {
  SafetyCertificateOutlined,
  TeamOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import { colors, fontSize } from "~/styles/tokens";
import { JourneyWhyExpander } from "./JourneyWhyExpander";

const { Title, Paragraph } = Typography;

interface TeamJourneySectionProps {
  isMobile: boolean;
}

/**
 * Team — org invite + lifecycle vs instance access lanes.
 */
export const TeamJourneySection: React.FC<TeamJourneySectionProps> = ({
  isMobile,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`journey-content${isMobile ? " is-mobile" : ""}`}>
      <Title level={isMobile ? 3 : 2} style={{ marginTop: 0 }}>
        {t("JourneyGuide_Team_Title")}
      </Title>
      <Paragraph
        className="journey-lead"
        style={{ fontSize: isMobile ? fontSize.body : fontSize.emphasis }}
      >
        {t("JourneyGuide_Team_Description")}
      </Paragraph>

      <div className="journey-team-invite">
        <span
          className="journey-team-invite-icon"
          style={{ background: colors.actionTertiary }}
          aria-hidden
        >
          <UserAddOutlined />
        </span>
        <div>
          <div className="journey-team-invite-label">
            {t("JourneyGuide_Team_Invite_Label")}
          </div>
          <p className="journey-team-invite-body">
            {t("JourneyGuide_Team_Invite_Body")}
          </p>
        </div>
      </div>

      <div className={`journey-access-lanes${isMobile ? " is-stacked" : ""}`}>
        <article className="journey-access-lane">
          <span
            className="journey-access-lane-icon"
            style={{ color: colors.actionPrimary }}
            aria-hidden
          >
            <TeamOutlined />
          </span>
          <div>
            <div className="journey-access-lane-label">
              {t("JourneyGuide_Team_Lifecycle_Label")}
            </div>
            <p className="journey-access-lane-body">
              {t("JourneyGuide_Team_Lifecycle_Body")}
            </p>
          </div>
        </article>
        <article className="journey-access-lane">
          <span
            className="journey-access-lane-icon"
            style={{ color: colors.actionSecondary }}
            aria-hidden
          >
            <SafetyCertificateOutlined />
          </span>
          <div>
            <div className="journey-access-lane-label">
              {t("JourneyGuide_Team_Instance_Label")}
            </div>
            <p className="journey-access-lane-body">
              {t("JourneyGuide_Team_Instance_Body")}
            </p>
          </div>
        </article>
      </div>

      <JourneyWhyExpander
        summaryKey="JourneyGuide_Team_Why_Summary"
        detailKey="JourneyGuide_Team_Why_Detail"
      />
    </div>
  );
};
